import React from 'react';

// If a theme crashes (e.g. WebGL unavailable, lazy chunk fails to load),
// drop the animation but keep the background + clock overlay alive.
export default class ThemeErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch() {
    // Intentionally silent: the screensaver must never take the app down.
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}
